function filterProducts(products, filterTags, banners, currentPage, priceFilters) {	
  //doesn't need to filter own category		
  var filteredProducts;	
  //filter products
  if (filterTags.length < 1) filteredProducts = products;
  else {	
    filteredProducts = products.filter((prod, index) => {
      var productTags = prod.tags.map((item, index) => {
        return item.replace(/\s+/g, '-').toLowerCase();
      });	
       return filterTags.some((tag, i) => {			
        return productTags.includes(tag);
      });	
    })	
  }
  
  //filtering products by price	
  if (priceFilters.length > 0) { 
    filteredProducts = filteredProducts.filter((prod) => {
      return priceFilters.some(filter => {	
        var prodPrice = Shopify.formatMoney(prod.price);	
        prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g,""))
        return prodPrice >= filter.min && prodPrice <= filter.max	
      });
    })	
  }
  
  //insert banners
  var withBanners = [];	
  filteredProducts.forEach((item, index) => {
    banners.forEach((banner, i) => {
      if (banner.number - 1 - i == index) {	
        withBanners = withBanners.concat({banner: true, url: banner.image, link: banner.link});				
      }
    });	
    var productImage = item.featured_image;	
    var colorsavailable ='';
    var colorcount = 0;
    var sizecount = 0;
    productImage = productImage.replace(".jpg?v=", "_300x.jpg?v=");

    for (let j = 0; j < item.options.length; j++) {
        if( item.options[j] == 'Color'){
           for (var i = 0; i < item.variants.length; i++) {
               colorcount += 1;
            }
        }
        else if( item.options[j] == 'Size') {
          for (var i = 0; i < item.variants.length; i++) {
               sizecount += 1;
            }
        }
        else{
          colorcount = 1;
        }
      }
    if (colorcount == 1){
      colorsavailable = 'Available in '+ item.variants.length +' Color';
    }
    else if (colorcount > 1){
      colorsavailable = 'Available in '+ item.variants.length +' Colors';
    }
    else if (sizecount == 1){
      //colorsavailable = item.variants.length +' Size';
    }
    else if (sizecount > 1){
      //colorsavailable = item.variants.length +' Sizes';
    }

    withBanners = withBanners.concat({banner: false, title: item.title, id: item.id, price: Shopify.formatMoney(item.price), url: '/products/' + item.handle, 
                                      image: productImage, available: item.available, colorcount: colorsavailable , compare_at_price : Shopify.formatMoney(item.compare_at_price)  })
  });	
  	
  //paginated products	
  var noPaginate = withBanners;
  withBanners = paginateProducts(withBanners, 15);		
  var $productContainer = $('#collection-hb');
  $productContainer.empty();
  
  	
  
  var current = currentPage - 1;
  while (!withBanners[current] && withBanners[0]) {
    current--;	
  }	
  var urlPage = current + 1;		
  if (withBanners.length < 1)
  {
    current = 0;
  }    
  else if (urlPage > 1){
    $('html,body').animate({ scrollTop: 100 }, 'slow');
    window.history.pushState(null, null, window.location.pathname.split('?')[0] + '?page=' + urlPage );    
  }
  
  Handlebars.registerHelper('lessThan', function (first, last, options) {		
    if (first < last) {		
      return options.fn(this)	
    } else {
      return options.inverse(this);	
    }
  });
  
  Handlebars.registerHelper('lessThanorEqual', function (first, last, options) {	
    if (first <= last) {	
      return options.fn(this)
    } else {
      return options.inverse(this);
    }
  });
	
  Handlebars.registerHelper("pageEquals", function(page, index , options) {
      if (page == index + 1) {
          return options.fn(this);
      } else {	
          return options.inverse(this);
      }
  });	
  
  Handlebars.registerHelper("returnPage", function(page) {
    return page + 1	
  });
  	
  Handlebars.registerHelper("noProducts", function(products, options) {	
    if (products.length < 1) {	
          return options.fn(this);
      } else {	
          return options.inverse(this);
      }	
  });
  Handlebars.registerHelper("hasProducts", function(products, options) {
    if (products.length > 1) {
          return options.fn(this);
      } else {	
          return options.inverse(this);
      }	
  });		
  var source = $('#ProductTemplate').html(),
  	  template = Handlebars.compile(source),      
      data = {
        productArr : withBanners[current],	
        filterArr: filterTags,
        numPages: withBanners.length, 
        allProducts: withBanners,	
        currentPage	: current + 1,	
        noPagProds: noPaginate,		
      };
  	
  $productContainer.append(template(data))		
  
  $( ".paginate-show-button" ).on("click", function(e) {	
    e.preventDefault();		
    $(".paginate-navigation, .paginate-product-row, .all-products, .paginate-show-button").toggleClass("show-products");
  });
		
  	
}

 function getCurrentFilters(tag, filterSelected) {	
  if (tag == "") return filterSelected		
  if (filterSelected.includes(tag)) {	
    filterSelected =  filterSelected.filter((item, index) => {
      return item !== tag	
    });		
    return filterSelected		
  } else {	
    filterSelected = filterSelected.concat(tag)	
    return filterSelected	
  }	
}		

function paginateProducts(products, size) {
  var paginatedProds = []
  var prods = [...products];	
  while (prods.length > 0) {
    paginatedProds.push(prods.splice(0, size));	
  }	
  return paginatedProds;		
}
